import { PageUrls } from '@/config/urls';
import { Navigate, useParams } from 'react-router-dom';

export default function ClientStatementRedirect() {
  const params = useParams();
  const { id } = params;

  return <Navigate to={`${PageUrls.STATEMENTS}/${id}/soft-goods`} replace />;
}
